
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { useAuth } from "@/hooks/useAuth";

interface QuoteDeleteDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const QuoteDeleteDialog = ({ isOpen, onClose, onConfirm }: QuoteDeleteDialogProps) => {
  const { user } = useAuth();

  const handleConfirm = async (e: React.MouseEvent) => {
    e.preventDefault(); // Prevent default dialog close behavior
    console.log('[QUOTE-DELETE-DIALOG] Delete confirmation triggered');
    console.log('[QUOTE-DELETE-DIALOG] User context:', {
      userId: user?.id,
      userEmail: user?.email,
      isAuthenticated: !!user
    });
    
    try {
      await onConfirm();
      onClose(); // Explicitly close after successful deletion
    } catch (error) {
      console.error('[QUOTE-DELETE-DIALOG] Error in confirmation handler:', error);
      onClose(); // Close even on error since error is already handled
    }
  };

  return (
    <AlertDialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Delete Quote</AlertDialogTitle>
          <AlertDialogDescription>
            Are you sure you want to delete this quote? This action cannot be undone and will permanently remove the quote from the system.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={handleConfirm} className="bg-red-600 hover:bg-red-700">
            Delete Quote
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default QuoteDeleteDialog;
